module.exports = __webpack_public_path__ + "img/terroir-grid-4-mobile.2b882cb9.jpg";